/**
 * an error that occurs when the machine clock is skewed
 * which causes the expiration time (exp) claim to be invalid
 */
const isClockSkewError = (error: unknown): boolean => {
  return (
    error instanceof Error && error.message.includes('Expiration Time (exp) claim error')
  )
}

export default isClockSkewError
